import { throwNotType, throwNull, throwUndefined } from '@esm-test/guards';
import { keywords } from '../keywords.js';

/**
 * Represents a field extracted from a module or object.
 */
export class ObjectField {
  /** The group name the field belongs to. */
  groupName: string;
  /** The name of the field (property name). */
  name: string;
  /** The value of the field. */
  value: any;

  /**
   * Initializes a new ObjectField instance.
   * @param groupName - Parent group name.
   * @param name - Property name.
   * @param value - Property value.
   */
  constructor(groupName: string, name: string, value: any) {
    throwNotType("groupName", groupName, "string");
    throwNotType("name", name, "string");

    throwUndefined("value", value);
    throwNull("value", value);

    this.groupName = groupName;
    this.name = name;
    this.value = value;
  }

  /** Whether this field represents the default export of a module. */
  get isDefaultExport(): boolean {
    return this.name == keywords.defaultExport;
  }

  /** Whether the field's value is a function. */
  get isFunction(): boolean {
    return this.value instanceof Function;
  }

  /** Whether the field's value is an array where the last element is a function (indicating test cases). */
  get isFunctionWithCases(): boolean {
    const value = this.value;
    return value instanceof Array
      && value.length > 0
      && value[value.length - 1] instanceof Function;
  }

  /** Whether the field's value has the 'cases' metadata attached (via decorator). */
  get hasCasesDecorator(): boolean {
    return this.value[keywords.cases] instanceof Array;
  }

}
